module.exports = {
          srcSet: __webpack_public_path__ + "fea60105099e319d8babb896bc69fa34-98.png"+" 98w",
          images:[ {path: __webpack_public_path__ + "fea60105099e319d8babb896bc69fa34-98.png",width: 98,height: 90}],
          src: __webpack_public_path__ + "fea60105099e319d8babb896bc69fa34-98.png",
          toString:function(){return __webpack_public_path__ + "fea60105099e319d8babb896bc69fa34-98.png"},
          
          width: 98,
          height: 90
        }